import { Navigate, useSearchParams } from "react-router-dom";

/**
 * /tenants/:id/dashboard used to be a separate "start a chat" page: a greeting,
 * an agent and channel picker and four suggestions, which on the first message
 * made a chat and then jumped to the chat page anyway. The chat's own empty
 * state now carries the greeting and suggestions, so there is one start screen.
 *
 * The address keeps working (links, bookmarks, the phone app, onboarding): it
 * opens a new chat with the same agent and channel.
 */
export function StartRedirect() {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams();
  const agentId = searchParams.get("agentId");
  const channelId = searchParams.get("channelId");
  if (agentId) params.set("agentId", agentId);
  if (channelId) params.set("channelId", channelId);
  params.set("newChat", "1");
  return <Navigate to={`../workspace?${params.toString()}`} replace />;
}
